import { fg } from '@confluence/feature-gating';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import UseDataRetentionDetailsQuery, {
	type useDataRetentionDetailsQuery$data,
	type useDataRetentionDetailsQuery$variables,
} from '../hooks/__generated__/useDataRetentionDetailsQuery.graphql';

interface PreloadDataRetentionQueryI {
	cloudId: string;
}

export const preloadDataRetentionPolicy = async ({ cloudId }: PreloadDataRetentionQueryI) => {
	if (!cloudId || !fg('dlp-dlm-data-retention-policy')) {
		return;
	}

	return query<useDataRetentionDetailsQuery$data, useDataRetentionDetailsQuery$variables>({
		query: UseDataRetentionDetailsQuery,
		variables: { cloudId },
		errorPolicy: 'all',
	});
};
